import { BugoData } from '@shared/api/bugo/bugo.interface';

// 부고 정보로 수령지 문자열 구성: "도로명주소, [장례식장명, 호실]"
// 시딩과 "원래 주소로" 복구가 같은 값을 쓰도록 한 곳에서 관리
export const composeReceiverAddress = (bugo: BugoData): string =>
  (bugo.fevent.funeralHomeInfoEmbed?.address ?? bugo.fevent.funeralHomeInfo.address) +
  ', [' +
  bugo.fevent.funeralHomeInfo.name +
  ', ' +
  (bugo.fevent.roomInfoEmbed?.name ?? bugo.fevent.roomInfo?.name ?? '') +
  ']';
